import { Card, Drawer, Form, Row, Col, Button, notification } from "antd";
import React, { Component } from "react";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import Request from "../../request";
import _ from 'lodash';

@Form.create()
class changeLeadStatus extends Component {
    state = {
        visible: true,
        leadStatusArr: [],
        loading: false,
    }

    onClose = () => {
        this.setState({ visible: false }, () => {
            this.props.onClose()
        });
    }

    loadInquiry = async () => {
        let { inquiryId, form: { setFieldsValue } } = this.props;
        let { doc } = await Request.getInquiry(inquiryId);
        let leadStatus = doc && doc.leadStatus ? doc.leadStatus : null;
        setTimeout(() => {
            setFieldsValue({ leadStatus });
        }, 20);
    }

    loadLeadStatus = async () => {
        let response = await Request.getLeadStatusDetails({
            results: 1000,
            count: 1000,
            desk: 'Front Desk'
        });
        let leadStatusArr = response.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.statusName });
            return temp;
        }, []);
        this.setState({ leadStatusArr });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form, inquiryId } = this.props;
        let { loading } = this.state;
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);
            this.setState({ loading: true });
            let response = await Request.updateInquiry({ _id: inquiryId, valData: values });
            this.setState({ loading: false });
            if (response.success) {
                notification.success({
                    message: 'Lead Status Updated Successfully'
                });
            } else {
                notification.error({
                    message: 'Something Went Wrong, Try Again!'
                });
            }

            this.onClose();
        })
    }

    componentDidMount() {
        this.loadLeadStatus();
        this.loadInquiry();
    }

    render() {
        let { visible, leadStatusArr, loading } = this.state;
        let { form: { setFieldsValue, getFieldDecorator } } = this.props;
        const inputTypes = {
            fields: [
                {
                    label: 'Lead Status',
                    key: 'leadStatus',
                    type: 'select',
                    required: true,
                    options: leadStatusArr,
                    onChange: v => {
                        setFieldsValue({ leadStatus: v });
                    }
                }
            ]
        }
        return (
            <Drawer
                title=""
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={500}
            >
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields
                            inputSchema={inputTypes}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <Row>
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={loading}>
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                </Card>
            </Drawer>
        )
    }
}


export default changeLeadStatus;